import { CardTypeEnum, GameStatusEnum } from '~/types/api/game';

export const gameStatusOptions = [
  {
    value: GameStatusEnum.Values.default,
    label: 'default',
  },
  {
    value: GameStatusEnum.Values.finished,
    label: 'finished',
  },
  {
    value: GameStatusEnum.Values['under-review'],
    label: 'underReview',
  },
  {
    value: GameStatusEnum.Values.canceled,
    label: 'canceled',
  },
];

export const cardsOptions = [
  {
    value: CardTypeEnum.Values.yellow,
    label: 'yellow',
  },
  {
    value: CardTypeEnum.Values.red,
    label: 'red',
  },
];
